export default import.meta.ROLLDOWN_FILE_URL_rRQ6Y3T8vZXU9nuHPuKfFQ